// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  DefaultMoreProps
} from "./plasmic/paziresh_24_profile/PlasmicMore";
import { HTMLElementRefOf } from "@plasmicapp/react-web";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface MoreProps extends Omit<DefaultMoreProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultMoreProps altogether and have
// total control over the props for your component.
export interface MoreProps extends DefaultMoreProps {}

function More_(_props: MoreProps, _ref: HTMLElementRefOf<"div">) {
  // Intentionally hidden: remove the header overflow (three-dots) menu.
  return null;
}

const More = React.forwardRef(More_);
export default More;
